import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import _ from "lodash";
import CKEditor from "react-ckeditor-component";
import renderHTML from "react-render-html";
import {
  get_faq_frontend,
  add_vote,
  get_faq_check_vote,
} from "../../../redux/actions/faqAction";
import loader from "../../../style/loader/loader.scss";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import languageConfig from "../../../config/languageConfig";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const history = createBrowserHistory();
class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",
      alreadySubmitted: "",
      faqsVoteInfo: {},
      recentlyVoted: [],
      faqDetails: [],
      isLoading: true,
      multi_lang: "no",
      lang: "",
      //default_lang: 'en',
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  showAnswer = (quesID) => (e) => {
    if (this.state.question === quesID) {
      this.setState({ question: "" });
    } else {
      this.setState({ question: quesID });
    }
  };

  handleClick = (voteParams, quesIDParams) => (e) => {
    this.props.add_vote({ vote: voteParams, quesID: quesIDParams });
    let votedQuestion = this.state.recentlyVoted;
    votedQuestion.push(quesIDParams);
    this.setState((recentlyVoted: votedQuestion));
  };

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    siteData.default_lang = lang;
    localStorage.setItem("siteDDBStatus", JSON.stringify(siteData));
    this.setState({
      default_lang: lang,
    });

    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang);
    this.props.getMenuList({
      page: 1,
      lang: lang,
      cityID: siteData.default_city,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: lang });
    }
  };

  handlePageChange = (page) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({
        userKey: cookies.get("token"),
        lang:
          siteData && siteData.default_lang
            ? siteData.default_lang
            : this.state.default_lang,
      });
    }
  };

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      this.setState({
        multi_lang: siteData.multi_lang,
        lang: siteData.lang,
        default_lang: siteData.default_lang,
      });
    }
    this.props.get_faq_frontend({
      lang: siteData.default_lang ? siteData.default_lang : this.state.lang,
    });
    this.props.get_faq_frontend({ lang: cookies.get("default_lang") });
  }
  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    let disableSubscriptionPopup = localStorage.getItem(
      "disableSubscriptionPopup"
    )
      ? localStorage.getItem("disableSubscriptionPopup")
      : false;
    let accessibleCities = localStorage.getItem("accessibleCities")
      ? JSON.parse(localStorage.getItem("accessibleCities"))
      : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);
    this.props.get_faq_frontend({ lang: cookies.get("default_lang") });

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }
  }
  componentWillReceiveProps(nextProps) {
//  this.props.get_faq_frontend({ lang: cookies.get("default_lang") });
   if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        this.setState({ default_lang: nextProps.language });
         this.props.get_faq_frontend({
      lang: nextProps.language,
    });
        //this.props.get_faq_frontend({ lang: cookies.get("default_lang") });
      }
    }
    if (
      this.props.faqFrontendDetails !== nextProps.faqFrontendDetails &&
      nextProps.faqFrontendDetails.length > 0
    ) {
      this.setState({ faqDetails: nextProps.faqFrontendDetails });
      nextProps.faqFrontendDetails.map((faq, index) => {
        this.props.get_faq_check_vote({ quesID: faq.quesID });
      });
    }
    if (this.props.addFaqVoteResponse !== nextProps.addFaqVoteResponse) {
      if (nextProps.addFaqVoteResponse.response === "success") {
        this.setState({
          alreadySubmitted: nextProps.addFaqVoteResponse.message,
        });
      }
    }
    if (this.props.faqVoteDetails !== nextProps.faqVoteDetails) {
      var faqObject = this.state.faqsVoteInfo;
      const quesID = nextProps.faqVoteDetails.data;
      if (!faqObject.hasOwnProperty(quesID)) {
        faqObject[quesID] = nextProps.faqVoteDetails.voted;
      }
      if (_.size(faqObject) === this.state.faqDetails.length) {
        this.setState({ isLoading: false });
      }
      this.setState({ faqVoteDetails: faqObject });
    }
  }

  render() {
    let faqRow;
    if (
      !isEmpty(this.props.faqFrontendDetails) &&
      this.props.faqFrontendDetails.length > 0 &&
      this.props.faqFrontendDetails.length === _.size(this.state.faqsVoteInfo)
    ) {
      faqRow = this.props.faqFrontendDetails.map((faq, index) => (
        <div id={faq.quesID}>
          <h4 onClick={this.showAnswer(faq.quesID)}>
            <i
              className="glyphicon glyphicon-question-sign"
              style={{ marginRight: "11px" }}
              aria-hidden="true"
            />
            {faq.question.charAt(0).toUpperCase() + faq.question.substr(1)}
          </h4>
          {faq.quesID === this.state.question && (
            <div
              style={{
                marginLeft: "25px",
                marginTop: "10px",
                marginBottom: "50px",
              }}
            >
              <div className="answer">{faq.answer}</div>
              {(this.state.alreadySubmitted &&
                this.state.recentlyVoted.indexOf(faq.quesID) > -1) ||
              this.state.faqsVoteInfo[faq.quesID] === "yes" ? (
                <div
                  style={{ float: "right", fontWeight: "bold", color: "grey" }}
                >
                  {this.state.alreadySubmitted &&
                  this.state.recentlyVoted.indexOf(faq.quesID) > -1
                    ? `${this.state.alreadySubmitted}!`
                    : this.state.faqsVoteInfo[faq.quesID] === "yes" &&
                      languageConfig[this.state.default_lang].thanks_feedback}
                </div>
              ) : (
                <div style={{ float: "right" }}>
                  <span>
                    {languageConfig[this.state.default_lang].find_helpful}
                  </span>
                  &nbsp;
                  <Button
                    bsStyle="info"
                    onClick={this.handleClick("up", faq.quesID)}
                  >
                    <i className="glyphicon glyphicon-thumbs-up" />
                    <span>{languageConfig[this.state.default_lang].yes}</span>
                  </Button>
                  &nbsp;
                  <Button
                    bsStyle="danger"
                    onClick={this.handleClick("down", faq.quesID)}
                  >
                    <i className="glyphicon glyphicon-thumbs-down" />
                    <span>{languageConfig[this.state.default_lang].no}</span>
                  </Button>
                  &nbsp;
                </div>
              )}
            </div>
          )}
        </div>
      ));
    }
    return (
      <div>
        {this.props.faqFrontendDetails &&
        this.props.faqFrontendDetails.length > 0 ? (
          <div className="container">
            {this.state.isLoading == true ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div>
              <div className="panel" style={{ marginTop: "40px" }}>
                <header className="panel-heading">
                  {languageConfig[this.state.default_lang].frequently_ask}
                </header>
                <div className="panel-body">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>
                      <Col md={12} xs={12}>
                        <div>
                          {
                            languageConfig[this.state.default_lang]
                              .click_question
                          }
                        </div>
                        {faqRow}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div>
              <div className="panel" style={{ marginTop: "10px" }}>
                <header className="panel-heading">
                  {languageConfig[this.state.default_lang].frequently_ask}
                </header>
                <div className="panel-body">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <Row>
                      <Col md={12} xs={12}>
                        <div>
                          {" "}
                          {
                            languageConfig[this.state.default_lang].no_faq_exit
                          }{" "}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Faq.propTypes = {
  get_static_page_details: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  faqFrontendDetails: state.faqReducer.faqFrontendDetails,
  addFaqVoteResponse: state.faqReducer.addFaqVoteResponse,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.termsPolicyAndContactReducer.error,
  faqVoteDetails: state.faqReducer.faqVoteDetails,
});
export default compose(
  // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  withRouter, 
  connect(mapStateToProps, { get_faq_frontend, add_vote, get_faq_check_vote })
)(Faq);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Faq.js